export const sr: Record<string, string> = {
  // Navigation
  dashboard: 'Kontrolna tabla',
  clients: 'Klijenti',
  treatments: 'Tretmani',
  reports: 'Izveštaji',
  settings: 'Podešavanja',
  billing: 'Naplata',
  team: 'Tim',
  locations: 'Lokacije',
  signOut: 'Odjavi se',
  saasPlatform: 'Klijentli SaaS Platform',
  
  // User Roles
  roleAdmin: 'Administrator',
  roleManager: 'Menadžer',
  roleTherapist: 'Terapeut',
  roleReceptionist: 'Recepcioner',
  
  // Dashboard Customizer
  customizeDashboard: 'Prilagodi kontrolnu tablu',
  visibleWidgets: 'Vidljivi vidžeti',
  hiddenWidgets: 'Sakriveni vidžeti',
  statisticsCards: 'Kartice statistike',
  statisticsCardsDescription: 'Ukupno klijenata, tretmana, prihoda i više',
  quickActions: 'Brze akcije',
  quickActionsDescription: 'Prečice do uobičajenih zadataka',
  recentVisits: 'Nedavne posete',
  recentVisitsDescription: 'Poslednji završeni tretmani',
  upcomingAppointments: 'Predstojeći termini',
  upcomingAppointmentsDescription: 'Zakazane posete u narednih 7 dana',
  layoutOptions: 'Opcije izgleda',
  statisticsGridColumns: 'Kolone mreže statistike',
  column: 'Kolona',
  columns: 'Kolone',
  resetToDefaults: 'Vrati na podrazumevano',
  saveChanges: 'Sačuvaj promene',
  saving: 'Čuvanje...',
  hide: 'Sakrij',
  show: 'Prikaži',
  moveUp: 'Pomeri gore',
  moveDown: 'Pomeri dole',
  failedToSavePreferences: 'Greška pri čuvanju preferenci. Molimo pokušajte ponovo.',
  
  // Role Manager
  users: 'Korisnici',
  userRolesAndPermissions: 'Uloge i dozvole korisnika',
  manageUserRolesAndPermissions: 'Upravljajte ulogama i dozvolama korisnika za vašu organizaciju',
  organizationMembers: 'Članovi organizacije',
  rolePermissionsOverview: 'Pregled dozvola uloga',
  roleDescriptions: 'Opisi uloga',
  clientManagement: 'Upravljanje klijentima',
  treatmentManagement: 'Upravljanje tretmanima',
  userManagement: 'Upravljanje korisnicima',
  reportsAndSettings: 'Izveštaji i podešavanja',
  organizationAndFinancial: 'Organizacija i finansije',
  viewColon: 'Pregled:',
  createColon: 'Kreiranje:',
  editColon: 'Izmena:',
  deleteColon: 'Brisanje:',
  manageRolesColon: 'Upravljanje ulogama:',
  viewReportsColon: 'Pregled izveštaja:',
  exportReportsColon: 'Izvoz izveštaja:',
  viewSettingsColon: 'Pregled podešavanja:',
  editSettingsColon: 'Izmena podešavanja:',
  manageLocationsColon: 'Upravljanje lokacijama:',
  viewFinancialsColon: 'Pregled finansija:',
  manageBillingColon: 'Upravljanje naplatom:',
  subscriptionColon: 'Pretplata:',
  roleAdminDescription: 'Pun pristup svim funkcijama. Može upravljati pretplatom, naplatom, lokacijama i svim organizacionim aspektima. Ima automatski pristup svim lokacijama kompanije.',
  roleManagerDescription: 'Upravljanje lokacijom i nadzor. Može upravljati osobljem na svojoj lokaciji, pregledati izveštaje i upravljati svakodnevnim operacijama. Ne može upravljati pretplatom ili drugim lokacijama.',
  roleTherapistDescription: 'Klinički pristup sa ograničenim administrativnim funkcijama. Može pregledati i kreirati klijente i tretmane, ali ne može brisati zapise ili upravljati korisnicima.',
  roleReceptionistDescription: 'Operacije recepcije. Može pregledati klijente, kreirati termine i zakazivati tretmane. Ograničene mogućnosti izmene.',
  adminLocationAccess: 'Pristup administratora lokacijama',
  adminLocationAccessDescription: 'Administratori imaju automatski pristup svim lokacijama u svojoj organizaciji, čak i bez eksplicitnih zapisa u location_access. Ovo osigurava da administratori uvek mogu upravljati i nadgledati sve organizacione operacije.',
  
  // Invitation Form
  inviteTeamMember: 'Pozovi člana tima',
  sendInvitationToJoinTeam: 'Pošaljite pozivnicu da se pridruže vašem timu',

  // Dashboard Page
  welcomeBack: 'Dobrodošli nazad',
  heresWhatsHappeningAt: 'Evo šta se dešava u',
  today: 'danas',
  customize: 'Prilagodi',
  totalClients: 'Ukupno klijenata',
  activeClientsInYourClinic: 'Aktivni klijenti u vašoj klinici',
  treatmentsCompletedThisMonth: 'Tretmani završeni ovog meseca',
  availableTreatmentTypes: 'Dostupni tipovi tretmana',
  revenue: 'Prihod',
  totalRevenueThisMonth: 'Ukupan prihod ovog meseca',
  addClient: 'Dodaj klijenta',
  createNewClientProfile: 'Kreirajte novi profil klijenta',
  scheduleTreatment: 'Zakaži tretman',
  bookNewTreatmentSession: 'Zakažite novu sesiju tretmana',
  viewReports: 'Pregledaj izveštaje',
  checkYourBusinessAnalytics: 'Proverite analitiku vašeg poslovanja',
  manageTreatments: 'Upravljaj tretmanima',
  configureTreatmentTypes: 'Konfigurišite tipove tretmana',
  recentActivity: 'Nedavne aktivnosti',
  recentVisitsTitle: 'Nedavne posete',
  upcomingAppointmentsTitle: 'Predstojeći termini',
  unknownClient: 'Nepoznat klijent',
  noTherapistAssigned: 'Nema dodeljenog terapeuta',
  noRecentActivity: 'Nema nedavnih aktivnosti',
  startByAddingFirstClient: 'Počnite dodavanjem prvog klijenta ili zakazivanjem tretmana.',

  // Treatments Page
  manageYourSkincaretreatmentsAndSessions: 'Upravljajte vašim tretmanima i sesijama',
  allTreatmentSessions: 'Sve sesije tretmana',
  noTreatmentsFound: 'Nije pronađen nijedan tretman',
  startBySchedulingYourFirstTreatment: 'Počnite zakazivanjem vašeg prvog tretmana.',
  addTreatment: 'Dodaj tretman',
  searchTreatments: 'Pretraži tretmane...',
  searchTreatmentsByClientOrType: 'Pretraži tretmane po klijentu ili tipu...',
  allCategories: 'Sve kategorije',
  completed: 'Završeno',
  scheduled: 'Zakazano',
  cancelled: 'Otkazano',
  sortByDate: 'Sortiraj po datumu',
  sortByName: 'Sortiraj po imenu',
  sortByPrice: 'Sortiraj po ceni',
  sortByDuration: 'Sortiraj po trajanju',
  ascending: 'Rastuće',
  descending: 'Opadajuće',
  client: 'Klijent',
  treatmentType: 'Tip tretmana',
  treatmentDate: 'Datum tretmana',
  duration: 'Trajanje',
  treatmentCost: 'Cena tretmana',
  status: 'Status',
  actions: 'Akcije',
  minutes: 'min',
  deleteTreatment: 'Obriši tretman',
  deleteTreatmentConfirmation: 'Da li ste sigurni da želite da obrišete ovaj tretman?',
  deleteTreatmentWarning: 'Ova akcija se ne može poništiti.',
  treatmentDeleted: 'Tretman je uspešno obrisan',
  failedToDelete: 'Neuspelo brisanje',
  previous: 'Prethodno',
  next: 'Sledeće',
  showing: 'Prikazuje se',
  to: 'do',
  of: 'od',
  results: 'rezultata',
  errorLoadingTreatments: 'Greška pri učitavanju tretmana',
  viewTreatment: 'Prikaži tretman',
  tryAgain: 'Pokušaj ponovo',
  tryAdjustingYourSearchTerms: 'Pokušajte da prilagodite pojmove pretrage',
  types: 'tipova',
  
  // Treatment Types Page
  manageTreatmentTypes: 'Upravljajte tipovima tretmana',
  addTreatmentType: 'Dodaj tip tretmana',
  search: 'Pretraga',
  searchTreatmentTypes: 'Pretraži tipove tretmana...',
  sortBy: 'Sortiraj po',
  order: 'Redosled',
  noTreatmentTypes: 'Nema tipova tretmana',
  noTreatmentTypesMessage: 'Počnite dodavanjem prvog tipa tretmana.',
  cost: 'Cena',
  notSpecified: 'Nije navedeno',
  deleteConfirmation: 'Potvrda brisanja',
  deleteTreatmentTypeConfirmation: 'Da li ste sigurni da želite da obrišete ovaj tip tretmana? Ova akcija se ne može poništiti.',
  treatmentTypeDeleted: 'Tip tretmana je uspešno obrisan',
  loading: 'Učitavanje...',
  close: 'Zatvori',
  
  // Treatment Type Translations (common types)
  // These are dynamic translations based on treatment type names from the database
  // Format: treatmentType_{normalizedName} where normalizedName is lowercase with spaces replaced by underscores
  
  // Treatment Page View Modes
  treatmentsHistory: 'Istorija tretmana',
  calendarView: 'Kalendarski pregled',
  appointmentsList: 'Lista termina',
  newAppointment: 'Novi termin',
  appointmentSavedSuccessfully: 'Termin je uspešno sačuvan',
  therapistHasConflict: 'Terapeut ima konflikt u ovom terminu',
  appointmentRescheduled: 'Termin je premešten',
  failedToRescheduleAppointment: 'Neuspelo premeštanje termina',
  appointmentDurationUpdated: 'Trajanje termina je ažurirano',
  failedToUpdateAppointmentDuration: 'Neuspelo ažuriranje trajanja termina',
  month: 'Mesec',
  week: 'Nedelja',
  day: 'Dan',
  
  // Treatment Page Filters
  allTherapists: 'Svi terapeuti',
  allStatuses: 'Svi statusi',
  startDate: 'Početni datum',
  endDate: 'Završni datum',
  resetFilters: 'Resetuj filtere',
  confirmed: 'Potvrđeno',
  noShow: 'Nedolazak',
  
  // Appointment Modal
  editAppointment: 'Izmeni termin',
  client: 'Klijent',
  therapist: 'Terapeut',
  treatmentTypes: 'Tipovi tretmana',
  startTime: 'Vreme početka',
  durationMinutes: 'Trajanje (minuti)',
  title: 'Naslov',
  optionalAppointmentTitle: 'Opcioni naslov termina',
  notes: 'Napomene',
  additionalNotes: 'Dodatne napomene...',
  pleaseFillRequiredFields: 'Molimo popunite sva obavezna polja',
  therapistHasConflict: 'Terapeut ima zakazan termin u ovom vremenu',
  appointmentCreatedSuccessfully: 'Termin je uspešno kreiran',
  appointmentUpdatedSuccessfully: 'Termin je uspešno ažuriran',
  failedToSaveAppointment: 'Neuspelo čuvanje termina',
  noTreatmentTypesAvailable: 'Nema dostupnih tipova tretmana',
  treatmentTypeSelected: 'tip tretmana izabran',
  treatmentTypesSelected: 'tipa tretmana izabrano',
  createRecurringAppointment: 'Kreiraj ponavljajući termin',
  pattern: 'Obrazac',
  every: 'Svaki',
  daysOfWeek: 'Dani u nedelji',
  endDateOptional: 'Završni datum (opciono)',
  daily: 'Dnevno',
  weekly: 'Nedeljno',
  monthly: 'Mesečno',
  create: 'Kreiraj',
  update: 'Ažuriraj',
  cancel: 'Otkaži',
  minutes: 'min',
  createAppointment: 'Kreiraj Termin',
  updateAppointment: 'Ažuriraj Termin',
  
  // Days of week (abbreviated)
  sun: 'Ned',
  mon: 'Pon',
  tue: 'Uto',
  wed: 'Sre',
  thu: 'Čet',
  fri: 'Pet',
  sat: 'Sub',

  // Locations Page
  manageLocations: 'Upravljaj lokacijama',
  addLocation: 'Dodaj lokaciju',
  searchLocation: 'Pretraži lokacije...',
  sortByAddress: 'Sortiraj po adresi',
  editLocation: 'Izmeni lokaciju',
  editLocationDescription: 'Ažurirajte informacije o lokaciji',
  updateLocation: 'Ažuriraj lokaciju',
  backToLocations: 'Nazad na lokacije',
  activeLocationDescription: 'Neaktivne lokacije neće biti dostupne za izbor',
  addLocationDescription: 'Kreirajte novu lokaciju za vaše poslovanje',
  failedToLoadLocation: 'Greška pri učitavanju lokacije',
  locationCreated: 'Lokacija je uspešno kreirana',
  locationUpdated: 'Lokacija je uspešno ažurirana',
  failedToCreate: 'Greška pri kreiranju',
  failedToUpdate: 'Greška pri ažuriranju',
  nameRequired: 'Ime je obavezno',
  invalidEmail: 'Neispravna email adresa',
  pleaseFixErrors: 'Molimo ispravite greške u formi',
  noPermissionToManageLocations: 'Nemate dozvolu za upravljanje lokacijama',
  loadingLocationData: 'Učitavanje podataka o lokaciji...',
  basicInformation: 'Osnovne informacije',
  name: 'Ime',
  enterLocationName: 'Unesite naziv lokacije',
  address: 'Adresa',
  enterAddress: 'Unesite punu adresu',
  contactInformation: 'Kontakt informacije',
  phone: 'Telefon',
  enterPhone: 'Unesite broj telefona',
  email: 'Email',
  enterEmail: 'Unesite email adresu',
  active: 'Aktivno',
  updating: 'Ažuriranje...',
  creating: 'Kreiranje...',
  createLocation: 'Kreiraj lokaciju',
  searchLocations: 'Pretraži lokacije...',
  locationDeleted: 'Lokacija je uspešno obrisana',
  location: 'Lokacija',
  contact: 'Kontakt',
  inactive: 'Neaktivno',
  noLocations: 'Nije pronađena nijedna lokacija',
  noLocationsMessage: 'Počnite kreiranjem vaše prve lokacije',
  deleteLocationConfirmation: 'Da li ste sigurni da želite da obrišete ovu lokaciju? Ova akcija se ne može poništiti.',

  // Company Settings Page
  companySettings: 'Podešavanja kompanije',
  manageCompanyInformationBrandingAndSubscription: 'Upravljajte informacijama o kompaniji, brendom i detaljima pretplate',
  editSettings: 'Izmeni podešavanja',
  companyInformation: 'Informacije o kompaniji',
  basicInformationAboutYourCompanyOrClinic: 'Osnovne informacije o vašoj kompaniji ili klinici',
  companyName: 'Naziv kompanije',
  enterCompanyName: 'Unesite naziv kompanije',
  website: 'Veb sajt',
  enterCompanyAddress: 'Unesite adresu kompanije',
  description: 'Opis',
  briefDescriptionOfYourCompanyOrClinic: 'Kratak opis vaše kompanije ili klinike',
  branding: 'Brending',
  customizeYourCompanysVisualIdentity: 'Prilagodite vizuelni identitet vaše kompanije',
  primaryColor: 'Primarna boja',
  secondaryColor: 'Sekundarna boja',
  subscription: 'Pretplata',
  manageYourSubscriptionPlanAndBilling: 'Upravljajte vašim planom pretplate i naplatom',
  currentPlan: 'Trenutni plan',
  trialEnds: 'Probni period se završava',
  changePlan: 'Promeni plan',
  billingHistory: 'Istorija naplate',
  teamManagement: 'Upravljanje timom',
  manageTeamMembersAndTheirRoles: 'Upravljajte članovima tima i njihovim ulogama',
  totalUsers: 'Ukupno korisnika',
  activeUsers: 'Aktivni korisnici',
  viewAllUsers: 'Prikaži sve korisnike',
  analyticsAndReports: 'Analitika i izveštaji',
  viewCompanyPerformanceAndAnalytics: 'Pregledajte performanse kompanije i analitiku',
  thisMonthRevenue: 'Prihod ovog meseca',
  activeClients: 'Aktivni klijenti',
  appointmentsThisMonth: 'Termini ovog meseca',
  viewDetailedReports: 'Prikaži detaljne izveštaje',
  exportData: 'Izvezi podatke',

  // Profile Page
  profile: 'Profil',
  manageYourPersonalInformationAndAccountSettings: 'Upravljajte vašim ličnim informacijama i podešavanjima naloga',
  personalInformation: 'Lične informacije',
  editProfile: 'Izmeni profil',
  profileUpdatedSuccessfully: 'Profil je uspešno ažuriran!',
  failedToUpdateProfile: 'Greška pri ažuriranju profila. Molimo pokušajte ponovo.',
  firstName: 'Ime',
  lastName: 'Prezime',
  firstNameRequired: 'Ime je obavezno',
  lastNameRequired: 'Prezime je obavezno',
  firstNameMinLength: 'Ime mora imati najmanje 2 karaktera',
  lastNameMinLength: 'Prezime mora imati najmanje 2 karaktera',
  enterYourFirstName: 'Unesite vaše ime',
  enterYourLastName: 'Unesite vaše prezime',
  emailAddress: 'Email adresa',
  emailRequired: 'Email je obavezan',
  invalidEmailAddress: 'Neispravna email adresa',
  enterYourEmailAddress: 'Unesite vašu email adresu',
  phoneNumber: 'Broj telefona',
  enterYourPhoneNumber: 'Unesite vaš broj telefona',
  changePassword: 'Promeni lozinku',
  currentPassword: 'Trenutna lozinka',
  newPassword: 'Nova lozinka',
  confirmNewPassword: 'Potvrdite novu lozinku',
  currentPasswordRequired: 'Trenutna lozinka je obavezna',
  newPasswordRequired: 'Nova lozinka je obavezna',
  confirmPasswordRequired: 'Molimo potvrdite vašu novu lozinku',
  passwordMinLength: 'Lozinka mora imati najmanje 8 karaktera',
  passwordsDoNotMatch: 'Lozinke se ne poklapaju',
  enterYourCurrentPassword: 'Unesite vašu trenutnu lozinku',
  enterYourNewPassword: 'Unesite vašu novu lozinku',
  confirmYourNewPassword: 'Potvrdite vašu novu lozinku',

  // Clients Page
  allClients: 'Svi klijenti',
  manageClientsFromAllYourAccessibleLocations: 'Upravljajte klijentima sa svih vaših dostupnih lokacija',
  errorLoadingClients: 'Greška pri učitavanju klijenata',
  tryAgain: 'Pokušajte ponovo',
  manageYourSkincareClientsAndTheirInformation: 'Upravljajte vašim klijentima i njihovim informacijama',
  searchClientsByNameEmailOrPhone: 'Pretražite klijente po imenu, email-u ili telefonu',
  lastVisit: 'Poslednja poseta',
  totalSpent: 'Ukupna potrošnja',
  view: 'Prikaz',
  grid: 'Mreža',
  list: 'Lista',
  showingXOfYClients: 'Prikazuje se {{x}} od {{y}} klijenata',
  showingXClients: 'Prikazuje se {{x}} klijenata',
  noClientsFound: 'Nije pronađen nijedan klijent',
  noClientsYet: 'Još uvek nemate klijente',
  tryAdjustingYourSearchTerms: 'Pokušajte da prilagodite vaše termine pretrage',
  getStartedByAddingYourFirstClient: 'Počnite dodavanjem vašeg prvog klijenta',
  yearsOld: 'god.',
  visits: 'poseta',
  viewClient: 'Pregledaj klijenta',
  deleteClient: 'Obriši klijenta',
  deleteClientConfirmation: 'Da li ste sigurni da želite da obrišete ovog klijenta? Ova akcija se ne može poništiti.',

  // Client Form
  back: 'Nazad',
  clientDetails: 'Detalji klijenta',
  editClient: 'Izmeni klijenta',
  profilePicture: 'Profilna slika',
  personalInformation: 'Lične informacije',
  firstName: 'Ime',
  lastName: 'Prezime',
  enterFirstName: 'Unesite ime',
  enterLastName: 'Unesite prezime',
  dateOfBirth: 'Datum rođenja',
  enterAddress: 'Unesite adresu',
  enterEmail: 'Unesite email',
  enterPhone: 'Unesite telefon',
  emergencyContact: 'Kontakt u hitnim slučajevima',
  emergencyContactName: 'Ime kontakta u hitnim slučajevima',
  emergencyPhone: 'Telefon za hitne slučajeve',
  emergencyPhoneNumber: 'Broj telefona za hitne slučajeve',
  skinInformation: 'Informacije o koži',
  selectSkinType: 'Izaberite tip kože',
  describeSkinConcerns: 'Opišite probleme sa kožom',
  medicalInformation: 'Medicinske informacije',
  medicalHistory: 'Medicinska istorija',
  relevantMedicalHistory: 'Relevantna medicinska istorija',
  listAllergies: 'Navedite alergije',
  medications: 'Lekovi',
  currentMedications: 'Trenutni lekovi',
  additionalInformation: 'Dodatne informacije',
  additionalNotes: 'Dodatne beleške',
  clientPreferences: 'Preferencije klijenta',
  updating: 'Ažuriranje...',
  creating: 'Kreiranje...',
  updateClient: 'Ažuriraj klijenta',
  createClient: 'Kreiraj klijenta',
  clientCreated: 'Klijent je kreiran',
  clientUpdated: 'Klijent je ažuriran',
  firstNameRequired: 'Ime je obavezno',
  lastNameRequired: 'Prezime je obavezno',
  invalidPhone: 'Nevažeći broj telefona',
  invalidEmergencyPhone: 'Nevažeći broj telefona za hitne slučajeve',
  saveClientFirstBeforeUploadingPhoto: 'Molimo sačuvajte klijenta pre nego što učitate fotografiju',
  loadingClientData: 'Učitavanje podataka klijenta...',
  
  // Skin Types
  normal: 'Normalna',
  dry: 'Suva',
  oily: 'Masna',
  combination: 'Kombinovana',
  sensitive: 'Osetljiva',
  acneProne: 'Sklona aknama',
  mature: 'Zrela',

  // Client Detail
  failedToLoadClient: 'Neuspešno učitavanje klijenta',
  clientDeleted: 'Klijent je obrisan',
  confirmDeleteClient: 'Da li ste sigurni da želite da obrišete ovog klijenta?',
  clientNotFound: 'Klijent nije pronađen',
  clientNotFoundMessage: 'Klijent koji tražite nije pronađen ili ne postoji.',
  backToClients: 'Nazad na klijente',
  clientId: 'ID klijenta',
  memberSince: 'Član od',
  lastUpdated: 'Poslednje ažuriranje',
  unknown: 'Nepoznato',
  none: 'Ništa',
  clientNotes: 'Beleške o klijentu',
  noNotes: 'Nema beleški',

  // Common actions
  add: 'Dodaj',
  edit: 'Izmeni',
  delete: 'Obriši',
  save: 'Sačuvaj',
  cancel: 'Otkaži',
  back: 'Nazad',
  next: 'Sledeći',
  previous: 'Prethodni',
  search: 'Pretraga',
  filter: 'Filter',
  sort: 'Sortiraj',
  view: 'Pregled',
  close: 'Zatvori',
  loading: 'Učitavanje...',
  noData: 'Nema podataka',
  actions: 'Akcije',
  contact: 'Kontakt',
  lastVisit: 'Poslednja poseta',
  quickActions: 'Brze akcije',
  name: 'Naziv',
  description: 'Opis',
  basicInformation: 'Osnovne informacije',

  // Client related
  clientId: 'ID klijenta',
  addClient: 'Dodaj klijenta',
  editClient: 'Izmeni klijenta',
  newClient: 'Novi klijent',
  clientDetails: 'Detalji klijenta',
  clientForm: 'Forma klijenta',
  manageClients: 'Upravljajte vašim klijentima za negu kože i njihovim informacijama',
  personalInformation: 'Lični podaci',
  contactInformation: 'Kontakt informacije',
  skinInformation: 'Informacije o koži',
  medicalInformation: 'Medicinski podaci',
  additionalInformation: 'Dodatne informacije',

  // Client fields
  firstName: 'Ime',
  lastName: 'Prezime',
  email: 'Email',
  phone: 'Telefon',
  dateOfBirth: 'Datum rođenja',
  address: 'Adresa',
  emergencyContact: 'Kontakt za hitne slučajeve',
  emergencyPhone: 'Telefon za hitne slučajeve',
  skinType: 'Tip kože',
  skinConcerns: 'Problemi sa kožom',
  medicalHistory: 'Medicinska istorija',
  allergies: 'Alergije',
  medications: 'Lekovi',
  notes: 'Napomene',
  preferences: 'Preferencije',

  // Skin types
  normal: 'Normalna',
  dry: 'Suva',
  oily: 'Masna',
  combination: 'Kombinovana',
  sensitive: 'Osetljiva',
  acneProne: 'Skłona aknama',
  mature: 'Zrela',

  // Treatment related
  addTreatment: 'Dodaj tretman',
  editTreatment: 'Izmeni tretman',
  newTreatment: 'Novi tretman',
  treatmentDetails: 'Detalji tretmana',
  treatmentType: 'Tip tretmana',
  treatmentDate: 'Datum tretmana',
  treatmentCost: 'Cena tretmana',
  treatmentNotes: 'Napomene o tretmanu',
  time: 'Vreme',
  and: 'i',
  noTime: 'Nema vremena',
  timeWillBeRoundedToNearest10Minutes: 'Vreme će biti zaokruženo na najbližih 10 minuta',
  lastTreatmentDate: 'Poslednji tretman',
  treatmentCount: 'broj tretmana',
  addNewTreatment: 'Dodaj novi tretman',
  selectClient: 'Izaberite klijenta',
  selectTreatmentType: 'Izaberite tip tretmana',
  duration: 'Trajanje (min)',
  therapist: 'Terapeut',
  selectTherapist: 'Izaberite terapeuta',
  noTherapistsFound: 'Nema pronađenih terapeuta',
  clearSelection: 'Obriši izbor',
  status: 'Status',
  completed: 'Završeno',
  scheduled: 'Zakazano',
  cancelled: 'Otkazano',
  observations: 'Zapažanja',
  measurements: 'Merenja',
  products: 'Proizvodi',
  homecare: 'Kućna nega',
  followUpDate: 'Datum kontrole',
  required: 'je obavezno',
  invalid: 'je nevažeće',
  manageTreatments: 'Upravljajte vašim tretmanima za negu kože',
  searchTreatments: 'Pretraži tretmane...',
  allCategories: 'Sve kategorije',
  facial: 'Facial',
  peel: 'Peel',
  resurfacing: 'Resurfacing',
  therapy: 'Therapy',
  sortByName: 'Sortiraj po imenu',
  sortByPrice: 'Sortiraj po ceni',
  sortByDuration: 'Sortiraj po trajanju',
  sortByDate: 'Sortiraj po datumu',
  treatment: 'Tretman',
  category: 'Kategorija',
  price: 'Cena',
  active: 'Aktivan',
  inactive: 'Neaktivan',
  deleteTreatment: 'Obriši tretman',

  // Treatment Types
  treatmentTypes: 'Tipovi tretmana',
  addTreatmentType: 'Dodaj tip tretmana',
  editTreatmentType: 'Izmeni tip tretmana',
  newTreatmentType: 'Novi tip tretmana',
  treatmentTypeDetails: 'Detalji tipa tretmana',
  manageTreatmentTypes: 'Upravljajte tipovima tretmana',
  searchTreatmentTypes: 'Pretraži tipove tretmana...',
  treatmentTypeCreated: 'Tip tretmana je uspešno kreiran!',
  treatmentTypeUpdated: 'Tip tretmana je uspešno ažuriran!',
  treatmentTypeDeleted: 'Tip tretmana je uspešno obrisan!',
  createTreatmentType: 'Kreiraj tip tretmana',
  updateTreatmentType: 'Ažuriraj tip tretmana',
  deleteTreatmentTypeConfirmation: 'Da li ste sigurni da želite da obrišete ovaj tip tretmana?',
  backToTreatmentTypes: 'Nazad na tipove tretmana',
  editTreatmentTypeDescription: 'Izmenite informacije o tipu tretmana',
  addTreatmentTypeDescription: 'Dodajte novi tip tretmana u sistem',
  loadingTreatmentTypeData: 'Učitavanje podataka o tipu tretmana...',
  failedToLoadTreatmentType: 'Greška pri učitavanju tipa tretmana',
  noTreatmentTypes: 'Nema tipova tretmana',
  noTreatmentTypesMessage: 'Započnite dodavanjem vašeg prvog tipa tretmana.',
  pricingAndDuration: 'Cenovnik i trajanje',
  minutes: 'minuta',
  enterTreatmentTypeName: 'Unesite naziv tipa tretmana',
  enterTreatmentTypeDescription: 'Unesite opis tipa tretmana',
  enterDuration: 'Unesite trajanje',
  enterCost: 'Unesite cenu',
  nameRequired: 'Naziv je obavezan',
  invalidDuration: 'Nevažeće trajanje',
  invalidCost: 'Nevažeća cena',
  selectCategory: 'Izaberite kategoriju',
  antiaging: 'Anti-aging',
  acne: 'Akne',
  sortByCategory: 'Sortiraj po kategoriji',

  // Dashboard
  welcome: 'Dobrodošli',
  overview: 'Pregled',
  recentActivity: 'Nedavna aktivnost',
  upcomingAppointments: 'Predstojeći termini',
  totalClients: 'Ukupno klijenata',
  totalTreatments: 'Ukupno tretmana',
  monthlyRevenue: 'Mesečni prihod',
  dashboardThisMonth: 'Ovog meseca',
  dashboardLastMonth: 'Prošlog meseca',
  createNewClientProfile: 'Kreirajte novi profil klijenta',
  scheduleNewTreatment: 'Zakažite novi tretman',
  recordTreatment: 'Zabeležite tretman',
  logNewTreatmentSession: 'Zabeležite novu sesiju tretmana',
  viewReports: 'Pregledajte izveštaje',
  checkBusinessAnalytics: 'Proverite poslovnu analitiku',
  toGlow: 'u Klijentli',
  yourSkincareClientManagementSystem: 'vaš sistem za upravljanje klijentima',
  addNewClient: 'Dodajte novog klijenta',
  configureServices: 'Konfigurišite usluge',

  // Reports
  revenueReport: 'Izveštaj o prihodima',
  clientReport: 'Izveštaj o klijentima',
  treatmentReport: 'Izveštaj o tretmanima',
  dateRange: 'Period',
  generateReport: 'Generiši izveštaj',
  export: 'Izvezi',
  filtersAndDateRange: 'Filteri i period',
  filterReportsByDateClientsAndMore: 'Filtrirajte izveštaje po datumu, klijentima, terapeutima i tipovima tretmana',
  quickRanges: 'Brzi periodi',
  last3Days: 'Poslednja 3 dana',
  last7Days: 'Poslednjih 7 dana',
  last30Days: 'Poslednjih 30 dana',
  last90Days: 'Poslednjih 90 dana',
  filterByClient: 'Filtriraj po klijentu',
  filterByTherapist: 'Filtriraj po terapeutu',
  filterByTreatmentType: 'Filtriraj po tipu tretmana',
  allTreatmentTypes: 'Svi tipovi tretmana',
  sortByClient: 'Sortiraj po klijentu',
  sortByTherapist: 'Sortiraj po terapeutu',
  sortByCost: 'Sortiraj po ceni',
  treatmentTypeBreakdown: 'Raspodela po tipovima tretmana',
  distributionOfTreatmentsByType: 'Distribucija tretmana po tipu',
  exportOptions: 'Opcije izvoza',
  downloadReportInVariousFormats: 'Preuzmite izveštaj u različitim formatima',
  exportCSV: 'Izvezi CSV',
  exportJSON: 'Izvezi JSON',
  exportPDF: 'Izvezi PDF',
  print: 'Štampaj',
  treatmentDetails: 'Detalji tretmana',
  noDataAvailable: 'Nema dostupnih podataka',
  tryAdjustingFilters: 'Pokušajte da prilagodite filtere ili period',
  exportSuccess: 'Izveštaj je uspešno izvezen',
  exportFailed: 'Neuspešan izvoz izveštaja',

  // Settings
  generalSettings: 'Opšta podešavanja',
  userProfile: 'Profil korisnika',
  security: 'Sigurnost',
  languagePreferences: 'Preferencije jezika',
  selectYourPreferredLanguage: 'Izaberite vaš željeni jezik za aplikaciju',
  language: 'Jezik',
  currentLanguage: 'Trenutni jezik',
  manageYourApplicationPreferencesAndConfiguration: 'Upravljajte vašim preferencama aplikacije i konfiguracijom',
  dashboardCustomization: 'Prilagođavanje kontrolne table',
  customizeYourDashboardLayoutAndWidgets: 'Prilagodite izgled i vidžete vaše kontrolne table',
  customizeDashboard: 'Prilagodi kontrolnu tablu',
  dataManagement: 'Upravljanje podacima',
  exportAndImportYourClinicSettings: 'Izvezite i uvezite podešavanja vaše klinike',
  exportSettings: 'Izvezi podešavanja',
  importSettings: 'Uvezi podešavanja',
  dataRetentionDays: 'Zadržavanje podataka (dana)',
  enableAnalytics: 'Omogući analitiku',
  collectUsageAnalytics: 'Prikupljaj analitiku korišćenja',
  systemInformation: 'Informacije o sistemu',
  applicationAndSystemDetails: 'Detalji aplikacije i sistema',
  version: 'Verzija',
  environment: 'Okruženje',
  development: 'Razvoj',
  databaseStatus: 'Status baze podataka',
  connected: 'Povezano',
  saveSettings: 'Sačuvaj podešavanja',

  // Messages
  clientCreated: 'Klijent je uspešno kreiran!',
  clientUpdated: 'Klijent je uspešno ažuriran!',
  clientDeleted: 'Klijent je uspešno obrisan!',
  treatmentCreated: 'Tretman je uspešno kreiran!',
  treatmentUpdated: 'Tretman je uspešno ažuriran!',
  treatmentDeleted: 'Tretman je uspešno obrisan!',
  failedToCreate: 'Greška pri kreiranju',
  failedToUpdate: 'Greška pri ažuriranju',
  failedToDelete: 'Greška pri brisanju',
  pleaseFixErrors: 'Molimo popravite greške u formi',

  // Validation messages
  firstNameRequired: 'Ime je obavezno',
  lastNameRequired: 'Prezime je obavezno',
  invalidEmail: 'Molimo unesite validnu email adresu',
  invalidPhone: 'Molimo unesite validan broj telefona (npr. 061 123 4567)',
  invalidEmergencyPhone: 'Molimo unesite validan broj telefona za hitne slučajeve (npr. 061 123 4567)',

  // Placeholders
  enterFirstName: 'Unesite ime',
  enterLastName: 'Unesite prezime',
  enterEmail: 'Unesite email adresu',
  enterPhone: 'Unesite broj telefona (npr. 061 123 4567)',
  enterAddress: 'Unesite adresu',
  emergencyContactName: 'Ime kontakta za hitne slučajeve',
  emergencyPhoneNumber: 'Broj telefona za hitne slučajeve (npr. 061 123 4567)',
  selectSkinType: 'Izaberite tip kože',
  describeSkinConcerns: 'Opisite probleme sa kožom',
  relevantMedicalHistory: 'Relevantna medicinska istorija',
  listAllergies: 'Lista alergija',
  currentMedications: 'Trenutni lekovi',
  additionalNotes: 'Dodatne napomene o klijentu',
  clientPreferences: 'Preferencije klijenta za tretmane',

  // Search and filters
  searchClients: 'Pretraži klijente...',
  allSkinTypes: 'Svi tipovi kože',
  sortBy: 'Sortiraj po',
  order: 'Redosled',
  ascending: 'Rastući',
  descending: 'Opadajući',
  dateAdded: 'Datum dodavanja',

  // Pagination
  showing: 'Prikazano',
  to: 'do',
  of: 'od',
  results: 'rezultata',
  perPage: 'po stranici',

  // Status and badges
  notSpecified: 'Nije navedeno',
  noTreatments: 'Nema tretmana',
  added: 'Dodato',
  updated: 'Ažurirano',
  created: 'Kreirano',
  none: 'Nema',
  unknown: 'Nepoznato',
  noVisits: 'Nema poseta',
  noNotes: 'Nema napomena',
  clientNotFound: 'Klijent nije pronađen',
  clientNotFoundMessage: 'Klijent koji tražite ne postoji.',
  backToClients: 'Nazad na klijente',
  confirmDeleteClient: 'Da li ste sigurni da želite da obrišete ovog klijenta? Ova akcija se ne može poništiti.',
  failedToLoadClient: 'Greška pri učitavanju klijenta',
  totalVisits: 'Ukupno poseta',
  memberSince: 'Član od',
  treatmentHistory: 'Istorija tretmana',
  clientNotes: 'Napomene o klijentu',
  cost: 'Cena',
  date: 'Datum',

  // Confirmation dialogs
  deleteConfirmation: 'Potvrda brisanja',
  deleteClientConfirmation: 'Da li ste sigurni da želite da obrišete',
  deleteClientWarning: 'Ova akcija se ne može poništiti i obrisaće sve povezane tretmane i fotografije.',
  deleteTreatmentConfirmation: 'Da li ste sigurni da želite da obrišete ovaj tretman?',
  deleteTreatmentWarning: 'Ova akcija se ne može poništiti.',

  // Loading states
  loadingClientData: 'Učitavanje podataka o klijentu...',
  creating: 'Kreiranje...',
  updating: 'Ažuriranje...',
  deleting: 'Brisanje...',

  // Error messages
  somethingWentWrong: 'Nešto je pošlo naopako',
  errorMessage: 'Izvinjavamo se, ali došlo je do neočekivane greške. Molimo pokušajte da osvežite stranicu.',
  refreshPage: 'Osveži stranicu',
  error: 'Greška',
  failedToLoadTreatment: 'Greška pri učitavanju tretmana',
  treatmentNotFound: 'Tretman nije pronađen',
  treatmentNotFoundMessage: 'Tretman koji tražite ne postoji.',
  backToTreatments: 'Nazad na tretmane',

  // Form actions
  createClient: 'Kreiraj klijenta',
  updateClient: 'Ažuriraj klijenta',
  createTreatment: 'Kreiraj tretman',
  updateTreatment: 'Ažuriraj tretman',
  lastUpdated: 'Poslednje ažuriranje',
  // Statistics
  statistics: 'Statistika',
  totalSpent: 'Ukupno potrošeno',
  averageTreatmentCost: 'Prosečna cena tretmana',
  firstTreatment: 'Prvi tretman',
  uniqueTreatmentTypes: 'Jedinstveni tipovi tretmana',
  treatmentBreakdown: 'Raspodela tretmana',
  in: 'u',
  revenue: 'Prihod',

  // Quick search
  quickSearch: 'Brza pretraga',
  searchPlaceholder: 'Pretraži po imenu, prezimenu, emailu ili telefonu...',

  // Empty states
  noClientsFound: 'Nema pronađenih klijenata',
  noClientsMessage: 'Pokušajte da prilagodite pretragu ili filtere.',
  noClientsEmptyMessage: 'Započnite dodavanjem vašeg prvog klijenta.',
  noTreatmentsFound: 'Nema pronađenih tretmana',
  noTreatmentsMessage: 'Pokušajte da prilagodite pretragu ili filtere.',
  noTreatmentsEmptyMessage: 'Započnite dodavanjem vašeg prvog tretmana.',

  // Photo gallery
  photos: 'Fotografije',
  addPhoto: 'Dodaj fotografiju',
  uploadPhoto: 'Otpremi fotografiju',
  photoDate: 'Datum fotografije',
  photoNotes: 'Napomene o fotografiji',

  // Calendar and dates
  today: 'Danas',
  yesterday: 'Juče',
  thisWeek: 'Ova nedelja',
  calendarThisMonth: 'Ovaj mesec',
  calendarLastMonth: 'Prošli mesec',
  dateFormat: 'dd.MM.yyyy',
  timeFormat: 'HH:mm',

  // Notifications
  markAsRead: 'Označi kao pročitano',
  markAllAsRead: 'Označi sve kao pročitano',
  noNotifications: 'Nema novih obaveštenja',

  // User profile
  profile: 'Profil',
  accountSettings: 'Podešavanja naloga',
  changePassword: 'Promeni lozinku',
  logout: 'Odjavi se',
  login: 'Prijavi se',
  register: 'Registruj se',

  // Help and support
  help: 'Pomoć',
  support: 'Podrška',
  documentation: 'Dokumentacija',
  contactSupport: 'Kontaktiraj podršku',
  feedback: 'Povratne informacije',

  // System messages
  systemMaintenance: 'Održavanje sistema',
  maintenanceMessage: 'Sistem je trenutno u održavanju. Molimo pokušajte ponovo kasnije.',
  sessionExpired: 'Sesija je istekla',
  sessionExpiredMessage: 'Vaša sesija je istekla. Molimo prijavite se ponovo.',
  networkError: 'Greška mreže',
  networkErrorMessage: 'Došlo je do greške u mreži. Molimo proverite vašu internet konekciju.',

  // Reports
  viewAnalyticsAndGenerateReports: 'Pregledajte analitiku i generišite izveštaje',
  monthlyTrends: 'Mesečni trendovi',
  revenueTrends: 'Trendovi prihoda',
  activeClients: 'Aktivni klijenti',
  averageRevenuePerClient: 'Prosečan prihod po klijentu',
  averageCost: 'Prosečna cena',
  uniqueClients: 'Jedinstveni klijenti',
  averageRevenuePerPeriod: 'Prosečan prihod po periodu',
  refresh: 'Osveži',
  lastTreatment: 'Poslednji tretman',

  // Success messages
  success: 'Uspešno',
  operationCompleted: 'Operacija je uspešno završena',
  dataSaved: 'Podaci su uspešno sačuvani',
  changesApplied: 'Promene su uspešno primenjene',

  // Warning messages
  warning: 'Upozorenje',
  unsavedChanges: 'Imate nesačuvane promene',
  unsavedChangesMessage: 'Da li ste sigurni da želite da napustite stranicu? Nesačuvane promene će biti izgubljene.',
  leavePage: 'Napusti stranicu',
  stayOnPage: 'Ostani na stranici',

  // Clients Page
  allClients: 'Svi klijenti',
  manageClientsFromAllYourAccessibleLocations: 'Upravljajte klijentima sa svih vaših dostupnih lokacija',
  errorLoadingClients: 'Greška pri učitavanju klijenata',
  tryAgain: 'Pokušaj ponovo',
  manageYourSkincareClientsAndTheirInformation: 'Upravljajte svojim klijentima i njihovim informacijama',
  addClient: 'Dodaj klijenta',
  searchClientsByNameEmailOrPhone: 'Pretraži klijente po imenu, emailu ili telefonu...',
  lastVisit: 'Poslednja poseta',
  totalSpent: 'Ukupno potrošeno',
  view: 'Pregled',
  grid: 'Mreža',
  list: 'Lista',
  showingXOfYClients: 'Prikazano {{x}} od {{y}} klijenata',
  showingXClients: 'Prikazano {{x}} klijenata',
  noClientsFound: 'Nije pronađen nijedan klijent',
  noClientsYet: 'Još nemate klijente',
  tryAdjustingYourSearchTerms: 'Pokušajte da prilagodite termine pretrage.',
  getStartedByAddingYourFirstClient: 'Počnite dodavanjem vašeg prvog klijenta.',
  yearsOld: 'godina',
  visits: 'poseta',
  viewClient: 'Prikaži klijenta',
  deleteClient: 'Obriši klijenta',
  deleteClientConfirmation: 'Da li ste sigurni da želite da obrišete ovog klijenta? Ova akcija se ne može poništiti.',
  unknownClient: 'Nepoznat klijent',

  // Documentation Page
  documentationTitle: 'Dokumentacija',
  documentationSubtitle: 'Kompletan vodič za korišćenje Klijentli-ja',
  backToDashboard: 'Nazad na kontrolnu tablu',
  tableOfContents: 'Sadržaj',
  needMoreHelp: 'Potrebna vam je dodatna pomoć?',
  needMoreHelpMessage: 'Ne možete da pronađete ono što tražite? Kontaktirajte administratora sistema ili se obratite podršci za pomoć.',
  goToDashboard: 'Idi na kontrolnu tablu',
  selectLanguage: 'Izaberite jezik',
  
  // Documentation Sections
  docGettingStarted: 'Prvi koraci',
  docClientManagement: 'Upravljanje klijentima',
  docTreatmentManagement: 'Upravljanje tretmanima',
  docTreatmentTypes: 'Katalog tipova tretmana',
  docPhotoManagement: 'Upravljanje fotografijama',
  docReportsAnalytics: 'Izveštaji i analitika',
  docTeamManagement: 'Upravljanje timom',
  docSettings: 'Podešavanja i preferencije',
  docWorkflows: 'Uobičajeni tokovi rada',
  docTipsBestPractices: 'Saveti i najbolje prakse',
  
  // Documentation Content - Getting Started
  docWelcomeToGlowCenter: 'Dobrodošli u Klijentli',
  docWelcomeDescription: 'Klijentli je sveobuhvatan sistem za upravljanje klijentima dizajniran posebno za stručnjake za negu kože, estetičare, dermatologe i kozmetičke klinike. Ova platforma vam pomaže da upravljate klijentima, pratite tretmane, čuvate fotografije i analizirate performanse vašeg poslovanja.',
  docLoggingIn: 'Prijavljivanje',
  docNavigateToLogin: 'Idite na stranicu za prijavljivanje na <code>/login</code>',
  docEnterEmailPassword: 'Unesite vašu email adresu i lozinku',
  docClickSignIn: 'Kliknite "Prijavi se" da pristupite vašem nalogu',
  docSelectLocation: 'Ako imate pristup više lokacija, izaberite vašu radnu lokaciju',
  docDashboardOverview: 'Pregled kontrolne table',
  docDashboardAfterLogin: 'Nakon prijavljivanja, videćete vašu personalizovanu kontrolnu tablu koja prikazuje:',
  docQuickStats: 'Brze statistike: Ukupno klijenata, današnji termini, prihod',
  docRecentClientActivity: 'Nedavne aktivnosti klijenata',
  docUpcomingAppointments: 'Predstojeći termini',
  docPerformanceMetrics: 'Metrije performansi i trendovi',
  docNavigation: 'Navigacija',
  docUseSidebarMenu: 'Koristite meni u bočnoj traci za navigaciju između različitih sekcija:',
  docNavDashboard: 'Kontrolna tabla 📊 - Vaš glavni pregled i statistika',
  docNavClients: 'Klijenti 👥 - Upravljajte profilima klijenata i informacijama',
  docNavTreatments: 'Tretmani 🏥 - Zabeležite i pratite sesije tretmana',
  docNavTreatmentTypes: 'Tipovi tretmana 🎯 - Upravljajte vašim katalogom usluga',
  docNavReports: 'Izveštaji 📈 - Analitika i poslovni uvid',
  docNavTeam: 'Tim 👨‍💼 - Upravljajte članovima tima i dozvolama',
  docNavSettings: 'Podešavanja ⚙️ - Konfigurišite vaše preferencije',
  
  // Documentation Content - Client Management
  docAddingNewClient: 'Dodavanje novog klijenta',
  docNavigateToClients: 'Idite na Klijenti iz menija u bočnoj traci',
  docClickAddClient: 'Kliknite dugme "Dodaj klijenta" u gornjem desnom uglu',
  docFillClientForm: 'Popunite formu sa informacijama o klijentu:',
  docPersonalDetails: 'Lični podaci (ime, email, telefon, datum rođenja)',
  docContactInfo: 'Kontakt informacije i adresa',
  docEmergencyContact: 'Detalji kontakta za hitne slučajeve',
  docClickSave: 'Kliknite "Sačuvaj" da kreirate profil klijenta',
  docClientProfileInfo: 'Informacije o profilu klijenta',
  docEachClientProfile: 'Svaki profil klijenta sadrži:',
  docBasicInfo: 'Osnovne informacije - Ime, kontakt detalji, demografija',
  docSkinAssessment: 'Procena kože - Tip kože (normalna, masna, suva, kombinovana, osetljiva)',
  docMedicalHistory: 'Medicinska istorija - Alergije, lekovi, medicinska stanja',
  docTreatmentHistory: 'Istorija tretmana - Kompletan zapis svih tretmana',
  docPhotoGallery: 'Galerija fotografija - Fotografije pre/posle sa praćenjem datuma',
  docNotes: 'Napomene - Prilagođene napomene i preferencije',
  docEditingClientInfo: 'Izmena informacija o klijentu',
  docGoToClientsList: 'Idite na listu klijenata i pronađite klijenta',
  docClickClientName: 'Kliknite na ime klijenta da vidite njihov profil',
  docClickEdit: 'Kliknite dugme "Izmeni"',
  docUpdateInfo: 'Ažurirajte potrebne informacije',
  docClickSaveChanges: 'Kliknite "Sačuvaj promene"',
  docSkinAssessmentSection: 'Procena kože',
  docDocumentSkinInfo: 'Dokumentujte detaljne informacije o koži uključujući:',
  docSkinType: 'Tip kože - Normalna, masna, suva, kombinovana ili osetljiva',
  docSkinConcerns: 'Problemi sa kožom - Akne, starenje, pigmentacija, osetljivost, itd.',
  docAllergies: 'Alergije - Alergije na proizvode i osetljivosti',
  docCurrentMedications: 'Trenutni lekovi - Relevantni lekovi koji utiču na tretmane',
  docSearchingFilteringClients: 'Pretraživanje i filtriranje klijenata',
  docUseSearchBar: 'Koristite traku za pretragu na vrhu stranice Klijenti da brzo pronađete klijente po imenu, email-u ili broju telefona. Pretraga se ažurira u realnom vremenu dok kucate.',
  
  // Documentation Content - Treatment Management
  docRecordingTreatmentSession: 'Zabeležavanje sesije tretmana',
  docNavigateToTreatments: 'Idite na Tretmani iz bočne trake',
  docClickNewTreatment: 'Kliknite dugme "Novi tretman"',
  docSelectClient: 'Izaberite klijenta iz padajućeg menija',
  docChooseTreatmentType: 'Izaberite tip tretmana iz vašeg kataloga',
  docFillTreatmentDetails: 'Popunite detalje tretmana:',
  docDateAndTime: 'Datum i vreme tretmana',
  docDuration: 'Trajanje',
  docPrice: 'Cena (automatski popunjeno iz tipa tretmana)',
  docTherapistPerforming: 'Terapeut koji izvodi tretman',
  docAddDetailedNotes: 'Dodajte detaljne napomene i zapažanja',
  docClickSaveTreatment: 'Kliknite "Sačuvaj tretman"',
  docTreatmentDocumentation: 'Dokumentacija tretmana',
  docComprehensiveRecords: 'Sveobuhvatni zapisi tretmana treba da uključuju:',
  docObservations: 'Zapažanja - Trenutno stanje kože, problemi koji su rešeni',
  docProductsUsed: 'Korišćeni proizvodi - Lista svih proizvoda primenjenih tokom tretmana',
  docTechniques: 'Tehnike - Metode i pristupi koji su korišćeni',
  docClientFeedback: 'Povratne informacije klijenta - Kako je klijent reagovao na tretman',
  docPhotos: 'Fotografije - Fotografije pre i posle tretmana',
  docHomecareInstructions: 'Uputstva za kućnu negu - Preporuke za negu posle tretmana',
  docNextSteps: 'Sledeći koraci - Preporučeni tretmani za praćenje i vremenski okvir',
  docViewingTreatmentHistory: 'Pregled istorije tretmana',
  docOpenClientProfile: 'Otvorite profil klijenta sa stranice Klijenti',
  docScrollToTreatmentHistory: 'Skrolujte do sekcije "Istorija tretmana"',
  docViewPastTreatments: 'Pregledajte sve prošle tretmane u hronološkom redosledu',
  docClickTreatment: 'Kliknite na bilo koji tretman da vidite potpune detalje',
  docCompareProgress: 'Uporedite napredak tokom vremena sa fotografijama i napomenama',
  docProgressTracking: 'Praćenje napretka',
  docTrackClientProgress: 'Pratite napredak klijenta poređenjem sesija tretmana tokom vremena. Pregledajte fotografije, napomene i zapažanja da izmerite efikasnost tretmana i prilagodite planove nege u skladu sa tim.',
  docEditingDeletingTreatments: 'Izmena ili brisanje tretmana',
  docToModifyTreatment: 'Da izmenite zapis tretmana:',
  docNavigateToTreatment: 'Idite na tretman sa liste Tretmani ili profila klijenta',
  docClickEditButton: 'Kliknite dugme "Izmeni"',
  docMakeChanges: 'Napravite vaše izmene',
  docNotePermissions: 'Napomena: Samo korisnici sa odgovarajućim dozvolama mogu da menjaju ili brišu zapise tretmana.',
  
  // Documentation Content - Treatment Types
  docManagingTreatmentTypes: 'Upravljanje tipovima tretmana',
  docTreatmentTypesDescription: 'Tipovi tretmana su vaš katalog usluga - različiti tretmani i usluge koje nudite. Pravilno postavljanje ovih osigurava konzistentnost i tačno određivanje cena.',
  docCreatingNewTreatmentType: 'Kreiranje novog tipa tretmana',
  docNavigateToTreatmentTypes: 'Idite na Tipovi tretmana iz bočne trake',
  docClickAddTreatmentType: 'Kliknite "Dodaj tip tretmana"',
  docFillTreatmentInfo: 'Popunite informacije o tretmanu:',
  docNameExample: 'Ime - npr., "Dubinsko čišćenje lica"',
  docDescription: 'Opis - Detaljan opis tretmana',
  docDurationMinutes: 'Trajanje - Tipično trajanje tretmana u minutima',
  docPrice: 'Cena - Standardna cena za ovaj tretman',
  docCategory: 'Kategorija - Opciona kategorizacija (Tretmani lica, Pilingi, Laser, itd.)',
  docClickSaveToAdd: 'Kliknite "Sačuvaj" da dodate u vaš katalog',
  docCommonTreatmentCategories: 'Uobičajene kategorije tretmana',
  docOrganizeServices: 'Organizujte vaše usluge u kategorije kao što su:',
  docFacials: 'Tretmani lica - Dubinsko čišćenje, hidratacija, anti-aging tretmani lica',
  docChemicalPeels: 'Hemijski pilingi - Lagani, srednji i duboki pilingi',
  docLaserTreatments: 'Laserski tretmani - Depilacija, resurfejsing, itd.',
  docMicroneedling: 'Mikroiglanje - Terapija indukcije kolagena',
  docInjectables: 'Injektabilni proizvodi - Botoks, fileri, itd.',
  docBodyTreatments: 'Tretmani tela - Omotavanje tela, pilingi, itd.',
  docSpecializedTreatments: 'Specijalizovani tretmani - Prilagođene ili specijalne usluge',
  docEditingTreatmentTypes: 'Izmena tipova tretmana',
  docUpdateTreatmentDetails: 'Možete da ažurirate detalje tretmana, cene ili opise u bilo kom trenutku. Izmene neće uticati na istorijske zapise tretmana, osiguravajući tačne istorijske podatke.',
  docBestPractices: 'Najbolje prakse',
  docKeepNamesConsistent: 'Zadržite imena tretmana jasna i konzistentna',
  docIncludeDetailedDescriptions: 'Uključite detaljne opise za referencu osoblja',
  docUpdatePricesRegularly: 'Ažurirajte cene redovno da odražavaju trenutne stope',
  docUseCategories: 'Koristite kategorije da organizujete vaš katalog',
  docSetRealisticDuration: 'Postavite realistična vremena trajanja za zakazivanje',
  
  // Documentation Content - Photo Management
  docUploadingPhotos: 'Otpremanje fotografija',
  docOpenClientProfileOrTreatment: 'Otvorite profil klijenta ili zapis tretmana',
  docNavigateToPhotos: 'Idite na sekciju "Fotografije"',
  docClickUploadPhoto: 'Kliknite "Otpremi fotografiju" ili prevucite i otpustite slike',
  docAddPhotoDetails: 'Dodajte detalje fotografije:',
  docPhotoType: 'Tip fotografije - Pre, Posle, Napredak ili Referenca',
  docBodyArea: 'Deo tela - Lice, vrat, šake, itd.',
  docAngle: 'Ugao - Spreda, levo, desno, pogled odozgo',
  docDate: 'Datum - Kada je fotografija snimljena',
  docNotes: 'Napomene - Dodatni kontekst ili zapažanja',
  docPhotoOrganization: 'Organizacija fotografija',
  docPhotosAutoOrganized: 'Fotografije se automatski organizuju po:',
  docDateChronological: 'Datum - Hronološki vremenski okvir napretka klijenta',
  docTreatmentSession: 'Sesija tretmana - Fotografije povezane sa određenim tretmanima',
  docType: 'Tip - Poređenja pre/posle',
  docBodyAreaGrouped: 'Deo tela - Grupisane po oblasti tretmana',
  docBeforeAfterComparisons: 'Poređenja pre/posle',
  docCreateCompellingComparisons: 'Kreirajte ubedljiva poređenja pre/posle:',
  docNavigateToPhotoGallery: 'Idite na galeriju fotografija klijenta',
  docSelectBeforePhoto: 'Izaberite fotografiju "Pre" sa vremenske linije',
  docClickCompare: 'Kliknite "Uporedi"',
  docSelectAfterPhoto: 'Izaberite odgovarajuću fotografiju "Posle"',
  docViewSideBySide: 'Pregledajte poređenje jedna pored druge',
  docOptionallySave: 'Opciono sačuvajte ili izvezite poređenje',
  docPhotoBestPractices: 'Najbolje prakse za fotografije',
  docUseConsistentLighting: 'Koristite konzistentno osvetljenje za tačna poređenja',
  docSameAngles: 'Fotografišite iz istih uglova svaki put',
  docEnsureConsent: 'Osigurajte pristanak klijenta pre snimanja fotografija',
  docCloseUpAndWide: 'Fotografišite i krupne planove i šire uglove',
  docNaturalLighting: 'Fotografišite u prirodnom osvetljenju kada je moguće',
  docTagImmediately: 'Označite fotografije odmah sa tačnim metapodacima',
  docHighQuality: 'Koristite visokokvalitetne slike (ali unutar ograničenja veličine)',
  docStorageAndPrivacy: 'Čuvanje i privatnost',
  docPhotosSecurelyStored: 'Sve fotografije su bezbedno čuvane i šifrovane. Pristup je ograničen samo na autorizovane članove tima. Fotografije se automatski rezervišu i mogu se izvesti ako je potrebno za zapise klijenata.',
  docSupportedFileFormats: 'Podržani formati fajlova',
  docSupportedFormats: 'Podržani formati: JPEG, PNG, WebP. Maksimalna veličina fajla: 10MB po fotografiji.',
  
  // Documentation Content - Reports & Analytics
  docDashboardMetrics: 'Metrije kontrolne table',
  docDashboardProvides: 'Vaša kontrolna tabla pruža uvid u realnom vremenu u vaše poslovanje:',
  docTotalClients: 'Ukupno klijenata - Trenutni broj aktivnih klijenata',
  docRevenueTrends: 'Trendovi prihoda - Dnevni, nedeljni, mesečni prihod',
  docTreatmentStatistics: 'Statistika tretmana - Popularni tretmani i učestalost',
  docClientActivity: 'Aktivnost klijenata - Novi klijenti, klijenti koji se vraćaju',
  docGrowthMetrics: 'Metrije rasta - Poređenja mesec za mesec',
  docViewingReports: 'Pregled izveštaja',
  docNavigateToReports: 'Idite na Izveštaji iz bočne trake',
  docSelectReportType: 'Izaberite tip izveštaja ili vremenski period',
  docViewCharts: 'Pregledajte interaktivne grafikone i dijagrame',
  docFilterByLocation: 'Filtrirajte po lokaciji, terapeutu ili tipu tretmana',
  docExportReports: 'Izvezite izveštaje u PDF ili Excel za dalju analizu',
  docAvailableReports: 'Dostupni izveštaji',
  docRevenueReport: 'Izveštaj o prihodima - Pregled prihoda po periodu',
  docTreatmentAnalysis: 'Analiza tretmana - Najpopularnije usluge',
  docClientRetention: 'Zadržavanje klijenata - Stope povratka i metrike lojalnosti',
  docTherapistPerformance: 'Performanse terapeuta - Individualna statistika osoblja',
  docGrowthTrends: 'Trendovi rasta - Dugoročni rast poslovanja',
  docClientDemographics: 'Demografija klijenata - Starost, lokacija, preferencije',
  docUsingAnalyticsForGrowth: 'Korišćenje analitike za rast',
  docLeverageData: 'Iskoristite vaše podatke da donesete informirane poslovne odluke:',
  docIdentifyProfitable: 'Identifikujte vaše najprofitabilnije tretmane',
  docTrackRetention: 'Pratite zadržavanje klijenata i potrebe za ponovnim angažovanjem',
  docMonitorProductivity: 'Nadgledajte produktivnost terapeuta i opterećenje',
  docSpotSeasonalTrends: 'Uočite sezonske trendove u vašem poslovanju',
  docMeasureMarketing: 'Izmerite efikasnost marketinških kampanja',
  docSetGoals: 'Postavite ciljeve i pratite napredak ka ciljevima',
  docExportingData: 'Izvoz podataka',
  docAllReportsExportable: 'Svi izveštaji mogu se izvesti u različitim formatima (PDF, Excel, CSV) za prezentacije, računovodstvene svrhe ili dublju analizu u spoljnim alatima.',
  
  // Documentation Content - Team Management
  docInvitingTeamMembers: 'Pozivanje članova tima',
  docNavigateToTeam: 'Idite na Tim iz bočne trake',
  docClickInviteTeamMember: 'Kliknite "Pozovi člana tima"',
  docEnterTeamMemberInfo: 'Unesite informacije o članu tima:',
  docEmailAddress: 'Email adresa',
  docFirstLastName: 'Ime i prezime',
  docRole: 'Uloga (Administrator, Menadžer, Terapeut, Recepcioner)',
  docLocationAccess: 'Pristup lokaciji (koje lokacije mogu da pristupe)',
  docClickSendInvitation: 'Kliknite "Pošalji pozivnicu"',
  docMemberReceivesEmail: 'Član tima će primiti email sa uputstvima za podešavanje',
  docUserRolesAndPermissions: 'Uloge i dozvole korisnika',
  docDifferentRoles: 'Različite uloge imaju različite nivoe pristupa:',
  docAdmin: 'Administrator - Potpuni pristup svim funkcijama i podešavanjima',
  docAdminManageCompany: 'Upravljajte podešavanjima kompanije i naplatom',
  docAdminCreateLocations: 'Kreirajte i upravljajte svim lokacijama',
  docAdminInviteMembers: 'Pozivajte i upravljajte svim članovima tima',
  docAdminAccessReports: 'Pristupite svim izveštajima i analitici',
  docManager: 'Menadžer - Upravljanje lokacijom i nadzor',
  docManagerManageLocations: 'Upravljajte dodeljenim lokacijama',
  docManagerInviteMembers: 'Pozivajte članove tima na svoje lokacije',
  docManagerViewReports: 'Pregledajte izveštaje i analitiku lokacije',
  docManagerManagePricing: 'Upravljajte tipovima tretmana i cenama',
  docTherapist: 'Terapeut - Svakodnevne operacije tretmana',
  docTherapistAddClients: 'Dodajte i upravljajte klijentima',
  docTherapistRecordTreatments: 'Zabeležite tretmane',
  docTherapistUploadPhotos: 'Otpremite i upravljajte fotografijama',
  docTherapistViewPerformance: 'Pregledajte svoje podatke o performansama',
  docReceptionist: 'Recepcioner - Operacije recepcije',
  docReceptionistViewClients: 'Pregledajte informacije o klijentima',
  docReceptionistSchedule: 'Zakazujte termine',
  docReceptionistLimitedEditing: 'Ograničene mogućnosti izmene',
  docManagingLocationAccess: 'Upravljanje pristupom lokaciji',
  docForMultiLocation: 'Za poslovanja sa više lokacija:',
  docOpenTeamMemberProfile: 'Otvorite profil člana tima',
  docNavigateToLocationAccess: 'Idite na sekciju "Pristup lokaciji"',
  docSelectLocations: 'Izaberite koje lokacije mogu da pristupe',
  docSaveChanges: 'Sačuvajte promene',
  docDataIsolation: 'Članovi tima mogu samo da pregledaju i upravljaju podacima za svoje dodeljene lokacije, osiguravajući pravilnu izolaciju podataka.',
  docEditingTeamMembers: 'Izmena članova tima',
  docToModifyRole: 'Da izmenite ulogu ili pristup člana tima, kliknite na njihovo ime na listi Tim, napravite potrebne izmene i kliknite "Sačuvaj promene". Izmene stupaju na snagu odmah.',
  docRemovingTeamMembers: 'Uklanjanje članova tima',
  docWhenRemoving: 'Kada uklanjate člana tima, njihov pristup se odmah oduzima. Istorijski podaci koje su kreirali (tretmani, napomene, itd.) ostaju u sistemu u svrhe vođenja zapisa.',
  
  // Documentation Content - Settings
  docUserSettings: 'Korisnička podešavanja',
  docCustomizePreferences: 'Prilagodite vaše lične preferencije:',
  docProfileInformation: 'Informacije o profilu - Ažurirajte vaše ime, email, telefon',
  docProfilePicture: 'Profilna slika - Otpremite profilnu fotografiju',
  docLanguage: 'Jezik - Izaberite vaš željeni jezik (Engleski, Srpski)',
  docNotifications: 'Obaveštenja - Konfigurišite email i obaveštenja u aplikaciji',
  docPassword: 'Lozinka - Promenite lozinku vašeg naloga',
  docDashboardLayout: 'Izgled kontrolne table - Prilagodite vidžete vaše kontrolne table',
  docCompanySettings: 'Podešavanja kompanije',
  docAdminOnly: '(Samo administrator) Konfigurišite podešavanja za celu kompaniju:',
  docCompanyInfo: 'Informacije o kompaniji - Ime, adresa, kontakt detalji',
  docBranding: 'Brendiranje - Logo, boje i vizuelni identitet',
  docBusinessHours: 'Radno vreme - Radno vreme za svaku lokaciju',
  docDefaultSettings: 'Podrazumevana podešavanja - Sistemska podrazumevana podešavanja za tretmane, cene',
  docIntegrations: 'Integracije - Povežite usluge trećih strana',
  docLocationSettings: 'Podešavanja lokacije',
  docConfigureLocation: 'Konfigurišite podešavanja pojedinačne lokacije:',
  docLocationDetails: 'Detalji lokacije - Adresa, telefon, email',
  docStaffAssignment: 'Dodela osoblja - Koji članovi tima rade na ovoj lokaciji',
  docOperatingHours: 'Radno vreme - Radno vreme za ovu lokaciju',
  docTreatmentAvailability: 'Dostupnost tretmana - Usluge koje se nude na ovoj lokaciji',
  docNotificationPreferences: 'Preferencije obaveštenja',
  docControlNotifications: 'Kontrolišite koja obaveštenja primate:',
  docNewAppointmentNotifications: 'Obaveštenja o novim terminima',
  docTreatmentReminders: 'Podsetnici za tretmane',
  docTeamActivityAlerts: 'Upozorenja o aktivnostima članova tima',
  docSystemUpdates: 'Ažuriranja sistema i obaveštenja',
  docSummaryReports: 'Nedeljni/mesečni sažeti izveštaji',
  docLanguageSelection: 'Izbor jezika',
  docGlowCenterSupports: 'Klijentli podržava više jezika. Promenite vašu jezičku preferencu u Podešavanja → Korisničke preferencije. Interfejs će se odmah ažurirati na vaš izabrani jezik.',
  docDataExportAndBackup: 'Izvoz podataka i rezervna kopija',
  docAdminOnlyExport: '(Samo administrator) Izvezite vaše podatke za rezervnu kopiju ili migraciju. Svi zapisi klijenata, tretmani i fotografije mogu se izvesti u standardnim formatima.',
  
  // Documentation Content - Workflows
  docCompleteClientOnboarding: 'Kompletno uvođenje klijenta',
  docCreateNewProfile: 'Kreirajte novi profil klijenta sa ličnim informacijama',
  docCompleteSkinAssessment: 'Završite procenu kože i medicinsku istoriju',
  docTakeInitialPhotos: 'Snimite početne fotografije "pre" iz više uglova',
  docDiscussGoals: 'Razgovarajte o ciljevima tretmana i kreirajte plan',
  docRecordFirstTreatment: 'Zabeležite prvu sesiju tretmana',
  docScheduleFollowUp: 'Zakazujte termine za praćenje',
  docSendHomecare: 'Pošaljite uputstva za kućnu negu',
  docTreatmentSessionWorkflow: 'Tok rada sesije tretmana',
  docOpenClientProfile: 'Otvorite profil klijenta sa kontrolne table ili liste klijenata',
  docReviewPrevious: 'Pregledajte prethodne napomene o tretmanu i fotografije',
  docTakeBeforePhotos: 'Snimite fotografije "pre tretmana" ako je potrebno',
  docCreateTreatmentRecord: 'Kreirajte novi zapis tretmana',
  docSelectTreatmentType: 'Izaberite tip tretmana iz kataloga',
  docPerformDocument: 'Izvedite i dokumentujte tretman',
  docTakeAfterPhotos: 'Snimite fotografije "posle tretmana"',
  docAddDetailedNotes: 'Dodajte detaljne napomene i zapažanja',
  docProvideHomecare: 'Obezbedite uputstva za kućnu negu',
  docScheduleNext: 'Zakazujte sledeći termin',
  docProcessPayment: 'Obradite plaćanje (ako je primenjivo)',
  docWeeklyReviewProcess: 'Nedeljni proces pregleda',
  docReviewMetrics: 'Pregledajte metrije kontrolne table i trendove',
  docCheckAppointments: 'Proverite predstojeće termine za nedelju',
  docFollowUpClients: 'Kontaktirajte klijente koji se nisu vratili',
  docReviewQuestions: 'Pregledajte i odgovorite na pitanja članova tima',
  docUpdateTreatmentTypes: 'Ažurirajte tipove tretmana ili cene ako je potrebno',
  docExportWeeklyReports: 'Izvezite nedeljne izveštaje za analizu',
  docMonthlyBusinessReview: 'Mesečni poslovni pregled',
  docGenerateRevenueReport: 'Generišite mesečni izveštaj o prihodima',
  docReviewRetention: 'Pregledajte metrike zadržavanja klijenata',
  docAnalyzePopularity: 'Analizirajte popularnost i profitabilnost tretmana',
  docReviewPerformance: 'Pregledajte performanse članova tima',
  docIdentifyTrends: 'Identifikujte trendove i prilike',
  docSetGoals: 'Postavite ciljeve za naredni mesec',
  docPlanMarketing: 'Planirajte marketinške ili promotivne aktivnosti',
  docNewTeamMemberSetup: 'Podešavanje novog člana tima',
  docSendInvitation: 'Pošaljite pozivnicu sa odgovarajućom ulogom',
  docAssignLocation: 'Dodelite pristup lokaciji',
  docCompleteProfile: 'Neka završe svoj profil',
  docProvideTraining: 'Obezbedite obuku o platformi',
  docReviewWorkflows: 'Pregledajte ključne tokove rada zajedno',
  docMonitorActivity: 'Nadgledajte njihovu početnu aktivnost',
  docAdjustPermissions: 'Prilagodite dozvole po potrebi',
  
  // Documentation Content - Tips & Best Practices
  docDataEntryTips: 'Saveti za unos podataka',
  docEnterNotesImmediately: 'Unesite napomene o tretmanu odmah nakon sesija dok su detalji sveži',
  docUseConsistentTerminology: 'Koristite konzistentnu terminologiju kroz sve zapise',
  docBeDetailedConcise: 'Budite detaljni ali sažeti u zapažanjima',
  docAlwaysIncludeCondition: 'Uvek uključite stanje kože i povratne informacije klijenta',
  docTagPhotosImmediately: 'Označite fotografije odmah sa tačnim metapodacima',
  docPhotoManagementTips: 'Saveti za upravljanje fotografijama',
  docConsistentLighting: 'Fotografišite u konzistentnim uslovima osvetljenja',
  docSameAnglesDistances: 'Koristite iste uglove i udaljenosti za uporedive snimke',
  docBeforeAfterEveryTreatment: 'Fotografišite pre i posle svakog značajnog tretmana',
  docStoreDeviceSameLocation: 'Čuvajte telefon/kameru na istom mestu radi konzistentnosti',
  docReviewBeforeSaving: 'Pregledajte fotografije pre čuvanja da osigurate kvalitet',
  docBackupPhotos: 'Rezervišite važne fotografije i van sistema',
  docClientCommunication: 'Komunikacija sa klijentima',
  docKeepCommunicationNotes: 'Čuvajte sve napomene o komunikaciji sa klijentima u njihovom profilu',
  docDocumentPreferences: 'Dokumentujte preferencije klijenata i posebne zahteve',
  docSetReminders: 'Postavite podsetnike za praćenje',
  docUseNotesField: 'Koristite polje za napomene za važan kontekst',
  docMaintainProfessional: 'Zadržite profesionalni jezik u svim zapisima',
  docSecurityBestPractices: 'Najbolje prakse bezbednosti',
  docAlwaysLogOut: 'Uvek se odjavite kada napuštate vašu radnu stanicu',
  docUseStrongPasswords: 'Koristite jake, jedinstvene lozinke',
  docNeverShareCredentials: 'Nikada ne delite podatke za prijavljivanje',
  docLockDevice: 'Zaključajte vaš uređaj kada odlazite',
  docReportSuspicious: 'Prijavite bilo koju sumnjivu aktivnost odmah',
  docKeepEmailSecure: 'Čuvajte vašu email lozinku bezbedno (za resetovanje lozinke)',
  docEfficiencyTips: 'Saveti za efikasnost',
  docSetUpTemplates: 'Postavite šablone tipova tretmana za uobičajene usluge',
  docUseSearchFunction: 'Koristite funkciju pretrage da brzo pronađete klijente',
  docCustomizeDashboard: 'Prilagodite vašu kontrolnu tablu da prikazuje najrelevantnije metrije',
  docLearnShortcuts: 'Naučite prečice na tastaturi za bržu navigaciju',
  docBatchTasks: 'Grupirajte slične zadatke zajedno (otpremanje fotografija, unos podataka)',
  docReviewReportsWeekly: 'Pregledajte izveštaje nedeljno da ostanete u toku sa trendovima',
  docClientSatisfaction: 'Zadovoljstvo klijenata',
  docUseBeforeAfter: 'Koristite fotografije pre/posle da pokažete napredak',
  docKeepDetailedRecords: 'Čuvajte detaljne zapise za konzistentnu negu',
  docSetAppointmentReminders: 'Postavite podsetnike za termine da smanjite nedolazke',
  docTrackRespond: 'Pratite i odgovorite na zabrinutosti klijenata odmah',
  docMaintainHistories: 'Čuvajte kompletne istorije tretmana za kontekst',
  docProvideClearInstructions: 'Obezbedite jasna uputstva za kućnu negu posle svakog tretmana',
  docBusinessGrowth: 'Rast poslovanja',
  docReviewAnalytics: 'Redovno pregledajte vašu analitiku da identifikujete prilike',
  docTrackProfitable: 'Pratite koje tretmane su najprofitabilniji',
  docMonitorRetention: 'Nadgledajte stope zadržavanja klijenata',
  docIdentifyTrends: 'Identifikujte trendove u zabrinutostima i potrebama klijenata',
  docUseDataForMarketing: 'Koristite podatke da informišete marketinške odluke',
  docSetMeasurableGoals: 'Postavite merljive ciljeve i pratite napredak',
  docTrainingNewStaff: 'Obuka novog osoblja',
  docHaveStaffReview: 'Neka novo osoblje detaljno pregleda ovu dokumentaciju',
  docCreatePracticeRecords: 'Kreirajte probne zapise klijenata za svrhe obuke',
  docShadowExperienced: 'U početku budite u pratnji iskusnih članova tima',
  docStartBasic: 'Počnite sa osnovnim zadacima i postepeno proširite pristup',
  docProvideFeedback: 'Obezbedite redovne povratne informacije tokom perioda učenja',
  docEncourageQuestions: 'Podstaknite pitanja i dokumentujte uobičajene probleme',

  // Photo Management
  photos: 'Fotografije',
  photoGallery: 'Galerija fotografija',
  uploadPhotos: 'Otpremi fotografije',
  uploadPhoto: 'Otpremi fotografiju',
  viewPhoto: 'Prikaži fotografiju',
  editPhoto: 'Izmeni fotografiju',
  deletePhoto: 'Obriši fotografiju',
  downloadPhoto: 'Preuzmi fotografiju',
  noPhotos: 'Nema fotografija',
  noPhotosYet: 'Još nema fotografija',
  noPhotosFound: 'Nije pronađena nijedna fotografija',
  photoUploadedSuccessfully: 'Fotografija je uspešno otpremljena',
  photoUpdatedSuccessfully: 'Fotografija je uspešno ažurirana',
  photoDeletedSuccessfully: 'Fotografija je uspešno obrisana',
  failedToUploadPhoto: 'Nije uspelo otpremanje fotografije',
  failedToUpdatePhoto: 'Nije uspelo ažuriranje fotografije',
  failedToDeletePhoto: 'Nije uspelo brisanje fotografije',
  failedToLoadPhotos: 'Nije uspelo učitavanje fotografija',
  failedToLoadImage: 'Nije uspelo učitavanje slike',
  confirmDeletePhoto: 'Da li ste sigurni da želite da obrišete ovu fotografiju? Ova akcija se ne može poništiti.',
  selectPhotosToUpload: 'Izaberite fotografije za otpremanje',
  dragAndDropPhotos: 'Prevucite i otpustite fotografije ovde, ili kliknite za pretraživanje',
  uploadingPhotos: 'Otpremanje fotografija...',
  uploadingPhoto: 'Otpremanje fotografije...',
  
  // Photo Types
  photoType: 'Tip fotografije',
  photoTypeBefore: 'Pre',
  photoTypeAfter: 'Posle',
  photoTypeProgress: 'Napredak',
  photoTypeReference: 'Referentna',
  photoTypeGeneral: 'Opšta',
  
  // Body Areas
  bodyArea: 'Deo tela',
  bodyAreaFace: 'Lice',
  bodyAreaForehead: 'Čelo',
  bodyAreaEyes: 'Oči',
  bodyAreaCheeks: 'Obrazi',
  bodyAreaNose: 'Nos',
  bodyAreaLips: 'Usne',
  bodyAreaChin: 'Brada',
  bodyAreaNeck: 'Vrat',
  bodyAreaChest: 'Grudi',
  bodyAreaHands: 'Šake',
  bodyAreaArms: 'Ruke',
  bodyAreaLegs: 'Noge',
  bodyAreaBack: 'Leđa',
  bodyAreaFullBody: 'Celo telo',
  bodyAreaOther: 'Ostalo',
  
  // Photo Angles
  photoAngle: 'Ugao fotografije',
  angleFront: 'Pogled sprijeda',
  angleLeft: 'Leva strana',
  angleRight: 'Desna strana',
  angleBack: 'Pogled sa leđa',
  angleTop: 'Pogled odozgo',
  angleBottom: 'Pogled odozdo',
  angleCloseUp: 'Krupni plan',
  angleWide: 'Široki ugao',
  angleOther: 'Ostalo',
  
  // Photo Metadata
  photoDetails: 'Detalji fotografije',
  photoMetadata: 'Metapodaci fotografije',
  takenDate: 'Datum snimanja',
  dateTaken: 'Datum snimanja',
  photoTitle: 'Naslov fotografije',
  photoDescription: 'Opis fotografije',
  associatedTreatment: 'Povezan tretman',
  noTreatmentSelected: 'Nije izabran tretman',
  selectTreatment: 'Izaberite tretman',
  allTreatments: 'Svi tretmani',
  noDate: 'Bez datuma',
  
  // Photo Gallery
  showingXPhotos: 'Prikazano {{x}} fotografija',
  filterPhotos: 'Filtriraj fotografije',
  sortPhotos: 'Sortiraj fotografije',
  sortByNewestFirst: 'Najnovije prvo',
  sortByOldestFirst: 'Najstarije prvo',
  sortByType: 'Po tipu',
  sortByTreatment: 'Po tretmanu',
  allPhotoTypes: 'Svi tipovi',
  allBodyAreas: 'Svi delovi tela',
  viewFullSize: 'Prikaži punu veličinu',
  comparisonMode: 'Režim poređenja',
  selectForComparison: 'Izaberi za poređenje',
  exitComparisonMode: 'Izađi iz režima poređenja',
  
  // Before/After Comparison
  beforeAfterComparison: 'Poređenje pre/posle',
  comparePhotos: 'Uporedi fotografije',
  selectTwoPhotos: 'Izaberite dve fotografije za poređenje',
  selectBeforePhoto: 'Izaberite fotografiju pre',
  selectAfterPhoto: 'Izaberite fotografiju posle',
  beforePhoto: 'Fotografija pre',
  afterPhoto: 'Fotografija posle',
  exportComparison: 'Izvezi poređenje',
  resetComparison: 'Resetuj poređenje',
  
  // Photo Validation
  invalidFileType: 'Nevažeći tip fajla. Dozvoljeni su samo JPEG, PNG i WebP.',
  fileTooLarge: 'Fajl je prevelik. Maksimalna veličina je 10MB.',
  selectAtLeastOnePhoto: 'Molimo izaberite bar jednu fotografiju',
  
  // Photo Actions
  photoActions: 'Akcije fotografije',
  bulkActions: 'Grupne akcije',
  selectPhotos: 'Izaberi fotografije',
  selectedXPhotos: '{{x}} fotografija izabrano',
  deleteSelectedPhotos: 'Obriši izabrane fotografije',
  downloadSelectedPhotos: 'Preuzmi izabrane fotografije',
  confirmDeleteMultiplePhotos: 'Da li ste sigurni da želite da obrišete {{count}} fotografija? Ova akcija se ne može poništiti.',
  
  // Empty States
  getStartedByUploadingPhotos: 'Počnite otpremanjem vaše prve fotografije.',
  uploadYourFirstPhoto: 'Otpremite vašu prvu fotografiju da biste pratili napredak klijenta.',
  noPhotosMatchingFilters: 'Nema fotografija koje odgovaraju trenutnim filterima.',
  tryChangingFilters: 'Pokušajte da promenite filtere ili otpremite nove fotografije.',
  
  // Photo Info
  photoCount: 'Broj fotografija',
  recentPhotos: 'Nedavne fotografije',
  viewAllPhotos: 'Prikaži sve fotografije',
  treatmentPhotos: 'Fotografije tretmana',
  clientPhotos: 'Fotografije klijenta',
  clientPhoto: 'Fotografija klijenta',
  
  // Additional Photo Translations
  noTitle: 'Bez naslova',
  untitled: 'Bez naslova',
  searchPhotos: 'Pretraži fotografije...',
  selectBodyArea: 'Izaberite deo tela',
  selectAngle: 'Izaberite ugao',
  enterTitle: 'Unesite naslov',
  enterDescription: 'Unesite opis',
  supportedFormats: 'Podržani formati',
  maxFileSize: 'Maksimalna veličina',
  ready: 'spremno',
  photo: 'fotografija',
  uploading: 'Otpremanje...',
  uploadAll: 'Otpremi sve',
  allPhotosUploaded: 'Sve fotografije su uspešno otpremljene',
  clearFilters: 'Obriši filtere',
  sortBy: 'Sortiraj po',
  saving: 'Čuvanje...',
  saveChanges: 'Sačuvaj promene',
  sideBySide: 'Jedna pored druge',
  slider: 'Klizač',
  before: 'Pre',
  after: 'Posle',
  uploadedOn: 'Otpremljeno',
  selectOneMorePhoto: 'Izaberite još jednu fotografiju za poređenje',
  clickToCompare: 'Kliknite ispod za prikaz poređenja',
  retry: 'Pokušaj ponovo',
  deleting: 'Brisanje...',
  
  // Company Settings
  companySettings: 'Podešavanja kompanije',
  manageCompanyInformationAndBranding: 'Upravljajte informacijama i brendiranjem kompanije',
  companyLogo: 'Logo kompanije',
  uploadYourCompanyLogo: 'Otpremite logo kompanije (preporučeno: 200x200px, PNG ili SVG)',
  companyInformation: 'Informacije o kompaniji',
  basicInformationAboutYourCompanyOrClinic: 'Osnovne informacije o vašoj kompaniji ili klinici',
  companyName: 'Naziv kompanije',
  enterCompanyName: 'Unesite naziv kompanije',
  email: 'Email',
  phone: 'Telefon',
  address: 'Adresa',
  enterCompanyAddress: 'Unesite adresu kompanije',
  regionalSettings: 'Regionalna podešavanja',
  configureTimezoneDateFormatAndCurrency: 'Konfigurišite vremensku zonu, format datuma i valutu',
  timezone: 'Vremenska zona',
  dateFormat: 'Format datuma',
  currency: 'Valuta',
  branding: 'Brendiranje',
  customizeYourCompanysVisualIdentity: 'Prilagodite vizuelni identitet vaše kompanije',
  primaryColor: 'Primarna boja',
  secondaryColor: 'Sekundarna boja',
  accentColor: 'Akcentna boja',
  preview: 'Pregled',
  primaryButton: 'Primarna dugme',
  secondaryButton: 'Sekundarno dugme',
  accentButton: 'Akcentno dugme',
  primaryTag: 'Primarna oznaka',
  secondaryTag: 'Sekundarna oznaka',
  accentTag: 'Akcentna oznaka',
  cardWithPrimaryColor: 'Kartica sa primarnom bojom',
  thisIsHowYourBrandColorsWillLook: 'Ovako će vaše boje brenda izgledati u raznim UI elementima kroz aplikaciju.',
  
  // Logo Upload
  dragAndDropOrClickToUpload: 'Prevucite i otpustite ili kliknite za otpremanje',
  png_jpg_svg_max2mb: 'PNG, JPG, SVG (maks 2MB)',
  changeLogo: 'Promeni logo',
  removeLogo: 'Ukloni logo',
  removing: 'Uklanjanje...',
  uploadingLogo: 'Otpremanje loga...',
  invalidFileTypeOnlyJpegPngSvgAllowed: 'Nevažeći tip fajla. Dozvoljeni su samo JPEG, PNG i SVG.',
  fileSizeTooLargeMax2mb: 'Fajl je prevelik. Maksimalna veličina je 2MB.',
  failedToUploadLogo: 'Neuspelo otpremanje loga',
  failedToRemoveLogo: 'Neuspelo uklanjanje loga',
  settingsUpdatedSuccessfully: 'Podešavanja uspešno ažurirana!',
  logoUploadedSuccessfully: 'Logo uspešno otpremljen!',
  logoRemovedSuccessfully: 'Logo uspešno uklonjen!',
  
  // Business Hours
  businessHours: 'Radno vreme',
  setTheOperatingHoursForEachLocation: 'Podesite radno vreme za svaku lokaciju',
  selectLocation: 'Izaberite lokaciju',
  operatingHours: 'Radno vreme',
  setTheBusinessHoursForThisLocation: 'Podesite radno vreme za ovu lokaciju',
  closed: 'Zatvoreno',
  open: 'Otvoreno',
  close: 'Zatvaranje',
  to: 'do',
  save: 'Sačuvaj',
  sunday: 'Nedelja',
  monday: 'Ponedeljak',
  tuesday: 'Utorak',
  wednesday: 'Sreda',
  thursday: 'Četvrtak',
  friday: 'Petak',
  saturday: 'Subota',
  pleaseEnterBothOpenAndCloseTimes: 'Molimo unesite i vreme otvaranja i zatvaranja',
  closeTimeMustBeAfterOpenTime: 'Vreme zatvaranja mora biti posle vremena otvaranja',
  failedToSaveBusinessHours: 'Neuspelo čuvanje radnog vremena',
  businessHoursUpdatedSuccessfully: 'Radno vreme uspešno ažurirano!',
  noLocationsFound: 'Nije pronađena nijedna lokacija',
  pleaseCreateALocationFirst: 'Molimo prvo kreirajte lokaciju za podešavanje radnog vremena.',
  
  // Default Settings
  defaultSettings: 'Podrazumevana podešavanja',
  configureDefaultValuesForTreatmentsAndOtherSettings: 'Konfigurišite podrazumevane vrednosti za tretmane i druga podešavanja',
  treatmentDefaults: 'Podrazumevano za tretmane',
  defaultValuesForNewTreatments: 'Podrazumevane vrednosti za nove tretmane',
  defaultTreatmentDurationMinutes: 'Podrazumevano trajanje tretmana (minuti)',
  defaultTreatmentPrice: 'Podrazumevana cena tretmana',
  requireNotesForTreatments: 'Zahtevaj beleške za tretmane',
  appointmentDefaults: 'Podrazumevano za termine',
  defaultValuesForNewAppointments: 'Podrazumevane vrednosti za nove termine',
  defaultAppointmentDurationMinutes: 'Podrazumevano trajanje termina (minuti)',
  sendReminderEmail: 'Pošalji email podsetnik',
  reminderTimeHoursBefore: 'Vreme podsetnika (sati pre)',
  howManyHoursBeforeAppointmentToSendReminder: 'Koliko sati pre termina poslati podsetnik',
  defaultSettingsUpdatedSuccessfully: 'Podrazumevana podešavanja uspešno ažurirana!',
  
  // Location Selector
  selectYourLocation: 'Izaberite vašu lokaciju',
  chooseLocationWhereYoullBeWorkingToday: 'Izaberite lokaciju na kojoj ćete danas raditi',
  createYourFirstLocationToGetStarted: 'Kreirajte vašu prvu lokaciju da biste počeli.',
  pleaseContactAdministratorForLocationAccess: 'Molimo kontaktirajte vašeg administratora da vam omogući pristup lokaciji.',
  createNewLocation: 'Kreiraj novu lokaciju',
  locationName: 'Naziv lokacije',
  locationNamePlaceholder: 'npr., Glavna klinika, Filijala centar',
  addressPlaceholder: 'Bulevar kralja Aleksandra 1, Beograd, 11000',
  phonePlaceholder: '(011) 123-4567',
  locationEmailPlaceholder: 'lokacija@primer.com',
  failedToSelectLocation: 'Neuspelo izabiranje lokacije',
  failedToCreateLocation: 'Neuspelo kreiranje lokacije',
  
  // Landing Page
  landingSignIn: 'Prijavi se',
  landingGetStarted: 'Započni',
  landingHeroTitle: 'Transformisi svoju',
  landingHeroTitleHighlight: 'ordinaciju',
  landingHeroTitleFormal: 'Transformišite svoju ordinaciju',
  landingHeroDescription: 'Sveobuhvatna platforma za profesionalce. Upravljajte klijentima, pratite tretmane, čuvajte fotografije i razvijajte svoju praksu sa pouzdanjem.',
  landingStartFreeTrial: 'Započni besplatnu probu',
  landingNoCreditCard: 'Bez kartice • 14-dnevna besplatna proba • Otkaži bilo kada',
  landingFeaturesTitle: 'Sve što vam je potrebno za uspeh',
  landingFeaturesSubtitle: 'Moćni alati dizajnirani posebno za profesionalce da upravljaju, prate i razvijaju svoju praksu.',
  landingFeatureClientManagement: 'Upravljanje klijentima',
  landingFeatureClientManagementDesc: 'Organizujte i pratite sve svoje klijente sa detaljnim profilima, istorijom tretmana i fotografijama napretka.',
  landingFeatureTreatmentTracking: 'Praćenje tretmana',
  landingFeatureTreatmentTrackingDesc: 'Zabeležite tretmane, pratite napredak i održavajte detaljne beleške za svaku sesiju sa klijentom.',
  landingFeaturePhotoManagement: 'Upravljanje fotografijama',
  landingFeaturePhotoManagementDesc: 'Čuvajte i organizujte fotografije pre/posle sa sigurnim skladištem u oblaku i lakim pristupom.',
  landingFeatureSecureCompliant: 'Sigurno i usklađeno',
  landingFeatureSecureCompliantDesc: 'HIPAA usklađena platforma sa korporativnom sigurnošću za zaštitu podataka vaših klijenata.',
  landingFeatureAppointmentScheduling: 'Zakazivanje termina',
  landingFeatureAppointmentSchedulingDesc: 'Pojednostavite proces rezervacije sa integrisanim zakazivanjem i upravljanjem kalendarom.',
  landingFeatureAnalyticsReports: 'Analitika i izveštaji',
  landingFeatureAnalyticsReportsDesc: 'Dobijte uvid sa detaljnim izveštajima o napretku klijenata, prihodima i poslovnim metrikama.',
  landingBenefitsTitle: 'Zašto izabrati Klijentli?',
  landingBenefitsSubtitle: 'Pridružite se hiljadama profesionalaca koji veruju Klijentli-u za upravljanje svojom praksom i pružanje izuzetnih iskustava klijentima.',
  landingBenefitStreamline: 'Pojednostavite svoju praksu',
  landingBenefitSatisfaction: 'Poboljšajte zadovoljstvo klijenata',
  landingBenefitProgress: 'Pratite napredak tretmana',
  landingBenefitStorage: 'Sigurno čuvanje podataka klijenata',
  landingBenefitPhotos: 'Profesionalno upravljanje fotografijama',
  landingBenefitAnalytics: 'Detaljna analitika i izveštavanje',
  landingResultsTitle: 'Stvarni rezultati',
  landingResultsClientSatisfaction: 'Zadovoljstvo klijenata',
  landingResultsTimeSaved: 'Ušteda vremena',
  landingResultsActiveUsers: 'Aktivnih korisnika',
  landingResultsUptime: 'Dostupnost',
  landingTestimonialsTitle: 'Omiljeno od profesionalaca',
  landingTestimonialsSubtitle: 'Pogledajte šta profesionalci kažu o Klijentli-u',
  landingTestimonial1Content: 'Klijentli je transformisao način na koji upravljam svojom praksom. Funkcija praćenja fotografija je neverovatna za prikazivanje napretka klijenata.',
  landingTestimonial2Content: 'Konačno, platforma koja razume profesionalce. Sistem za upravljanje klijentima je intuitivan i moćan.',
  landingTestimonial3Content: 'Funkcije sigurnosti i usklađenosti mi daju mir. Moji klijenti veruju da su njihovi podaci sigurni.',
  landingCTATitle: 'Spremni da transformišete svoju praksu?',
  landingCTASubtitle: 'Pridružite se hiljadama profesionalaca koji veruju Klijentli-u za upravljanje svojom praksom i pružanje izuzetnih rezultata.',
  landingCTAStartTrial: 'Započni besplatnu probu',
  landingFooterDescription: 'Kompletna platforma za profesionalce.',
  landingFooterProduct: 'Proizvod',
  landingFooterSupport: 'Podrška',
  landingFooterLegal: 'Pravno',
  landingFooterFeatures: 'Funkcije',
  landingFooterPricing: 'Cenovnik',
  landingFooterSecurity: 'Sigurnost',
  landingFooterHelpCenter: 'Centar za pomoć',
  landingFooterContact: 'Kontaktirajte nas',
  landingFooterStatus: 'Status',
  landingFooterPrivacy: 'Politika privatnosti',
  landingFooterTerms: 'Uslovi korišćenja',
  landingFooterRefund: 'Politika povraćaja',
  landingFooterHIPAA: 'HIPAA usklađenost',
  landingFooterCopyright: '© 2025 Klijentli. Sva prava zadržana.',
  landingFooterPoweredBy: 'Pokreće',
  landingLanguageSwitcher: 'Jezik',
  
  // Cookie Consent
  cookieConsentTitle: 'Saglasnost za kolačiće',
  cookieConsentDescription: 'Koristimo kolačiće da poboljšamo vaše iskustvo pregledanja, analiziramo saobraćaj na sajtu i personalizujemo sadržaj. Klikom na "Prihvati sve", pristajete na naše korišćenje kolačića.',
  cookieConsentNecessary: 'Neophodni kolačići su potrebni za pravilno funkcionisanje sajta. Ovi kolačići se ne mogu onemogućiti.',
  cookieConsentAnalytics: 'Analitički kolačići nam pomažu da razumemo kako posetioce koriste naš sajt prikupljanjem i prijavljivanjem informacija anonimno.',
  cookieConsentAdvertising: 'Reklamni kolačići se koriste za isporuku personalizovanih reklama i praćenje efikasnosti kampanja.',
  cookieConsentAcceptAll: 'Prihvati sve',
  cookieConsentRejectAll: 'Odbij sve',
  cookieConsentSavePreferences: 'Sačuvaj postavke',
  cookieConsentCustomize: 'Prilagodi',
  cookieConsentLearnMore: 'Saznaj više',
};
